import type { ThingsToKnowLayoutMode } from 'components/Common/ThingsToKnow/ThingsToKnowLayout'
import BedbankThingsToKnow from 'components/Common/ThingsToKnow/BedbankThingsToKnow'
import ThingsToKnow from 'components/OfferPage/ThingsToKnow/ThingsToKnow'
import PropertyThingsToKnowContent from './PropertyThingsToKnowContent'

export type AccommodationThingsToKnowSource =
  | { kind: 'property', property: App.Property.Property }
  | { kind: 'flash', offer: App.Offer }
  | { kind: 'bedbank', offer: App.BedbankOffer }

export function hasAccommodationThingsToKnow(source: AccommodationThingsToKnowSource): boolean {
  if (source.kind !== 'flash') return true

  return !!(source.offer.finePrint || source.offer.inclusions || source.offer.facilities)
}

interface Props {
  source: AccommodationThingsToKnowSource
  mode?: ThingsToKnowLayoutMode
}

function AccommodationThingsToKnow({ source, mode }: Props) {
  if (source.kind === 'property') {
    return <PropertyThingsToKnowContent property={source.property} mode={mode} />
  }

  if (source.kind === 'bedbank') {
    return <BedbankThingsToKnow offer={source.offer} mode={mode} />
  }

  return <ThingsToKnow offer={source.offer} mode={mode} />
}

export default AccommodationThingsToKnow
